<template>
  <div class="app-container" style="width: 100%; height: 100vh; display: flex">
    <iframe :src="iframeUrl" frameborder="0" style="flex: 1" />
  </div>
</template>

<script>
import { getDashboardParams } from '@/api/orderApi';

export default {
  name: 'TrajectoryPushBoard',
  data() {
    return {
      iframeUrl: ''
    };
  },
  activated() {
    getDashboardParams(5).then((res) => {
      if (res.code === 200) {
        this.iframeUrl = `https://share.tcbi.qq.com/page/embed?authType=${res.data?.authType}&pageId=${res.data?.pageId}&projectId=${res.data?.projectId}&scope=${res.data?.scope}&token=${res.data?.token}`;
      }
    });
  },
  created() {
    getDashboardParams(5).then((res) => {
      if (res.code === 200) {
        this.iframeUrl = `https://share.tcbi.qq.com/page/embed?authType=${res.data?.authType}&pageId=${res.data?.pageId}&projectId=${res.data?.projectId}&scope=${res.data?.scope}&token=${res.data?.token}`;
      }
    });
  },
  methods: {}
};
</script>

<style scoped></style>
